import eventLib from './index';
/* 监听是否展示全局loading */
export function onLoading(callback) {
  eventLib.on('loading', callback);
}
/* 监听路由跳转 */
export function onNavigate(callback) {
  eventLib.on('navigate', callback);
}
